import {
  BillingIntervalSchema,
  BillingTypeSchema,
  CardSchema,
  FeaturesSummary,
  InternalStatusSchema,
  ProductCodeSchema,
  StripeSubscriptionStatusSchema,
} from "@supernova-studio/model";
import z from "zod";

export const DTOSubscription = z.object({
  stripeSubscriptionId: z.string().optional(),
  stripeCustomerId: z.string().optional(),

  status: InternalStatusSchema.optional(),
  subscriptionStatus: StripeSubscriptionStatusSchema.optional(),
  internalStatus: InternalStatusSchema.optional(),

  product: ProductCodeSchema,
  featuresSummary: FeaturesSummary.optional(),
  stripeProductDescription: z.string().optional(),
  stripeProductFeatures: z.array(z.string()).optional(),
  stripeProductAdditionalFeatures: z.array(z.string()).optional(),
  stripeSubscriptionMainItemId: z.string().optional(),
  planPriceId: z.string(),
  planInterval: BillingIntervalSchema,
  isPricePerCreator: z.boolean().optional(),
  legacyVersion: z.string().optional(),

  seats: z.number(),
  seatLimit: z.number(),

  currentPeriodStart: z.string().optional(),
  currentPeriodEnd: z.string().optional(),
  subscriptionStatusUpdatedAt: z.string().optional(),
  cancelAt: z.string().nullish(),

  card: CardSchema.optional(),

  // New
  amount: z.number(),
  isTrial: z.boolean(),
  billingType: BillingTypeSchema.optional(),
  daysUntilDue: z.number().optional(),
});

export const DTOSubscriptionResponse = z.object({
  subscription: DTOSubscription,
});

export type DTOSubscription = z.infer<typeof DTOSubscription>;
export type DTOSubscriptionResponse = z.infer<typeof DTOSubscriptionResponse>;
